// extracted by mini-css-extract-plugin
export default {"radioWrapper":"index_snow_radioWrapper__gpJj7"};